import { Admin } from '../types';

export const mockAdmins: Admin[] = [
  {
    id: 'a1234567-89ab-cdef-0123-456789abcdef',
    firstName: 'Admin',
    lastName: 'User',
    email: 'admin@school.edu',
  },
];
